module.exports = __webpack_public_path__ + "static/img/xiaotiancai.d1917c83.png";